/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Src_3_DetailInputs */

const en_wb_operations_src_3_detail = /** @type {(inputs: Wb_Operations_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery address required`)
};

const lv_wb_operations_src_3_detail = /** @type {(inputs: Wb_Operations_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piegādes adrese ir obligāta`)
};

/**
* | output |
* | --- |
* | "Delivery address required" |
*
* @param {Wb_Operations_Src_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_src_3_detail = /** @type {((inputs?: Wb_Operations_Src_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Src_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_src_3_detail(inputs)
	return en_wb_operations_src_3_detail(inputs)
});